export { default as JssThemeProvider } from './JssThemeProvider';
